<template>
  <div class="text-white pa-3 d-flex flex-column">
    <h2 class="mb-2">Quick Queries</h2>
    <router-link to="/search/texts" class="text-white no-underline">
      Go to advanced queries <v-icon>mdi-icon-right</v-icon>
    </router-link>
    <search-field
      class="sidebar-search-field test-text-input"
      label="Text Name"
      v-model="text"
      @enter="performSearch"
      :disabled="textSearchDisabled"
      :textNameDisplayHelp="true"
    />
    <search-field
      class="sidebar-search-field test-transliteration-input"
      label="Transliteration"
      v-model="translit"
      @enter="performSearch"
      :disabled="textSearchDisabled"
      :transliterationDisplayHelp="true"
    />
    <search-field
      class="sidebar-search-field test-words-input"
      label="Words"
      v-model="word"
      @enter="performSearch"
      :disabled="dictionaryDisabled"
      v-if="canDictionarySearch"
    />
    <v-btn
      color="error"
      variant="elevated"
      class="mb-3 test-clear-btn"
      @click="clearSearch"
      >Clear</v-btn
    >
    <v-btn
      color="info"
      variant="elevated"
      class="mb-3 test-search-btn"
      :disabled="!canSearch"
      @click="performSearch"
      >Search</v-btn
    >
  </div>
</template>

<script lang="ts">
import { defineComponent, computed, ref } from 'vue';
import SearchField from './SearchField.vue';
import sl from '@/serviceLocator';

export default defineComponent({
  name: 'OareSidebar',
  components: {
    SearchField,
  },
  setup() {
    const store = sl.get('store');
    const text = ref('');
    const translit = ref('');
    const word = ref('');

    const textSearchDisabled = computed(() => word.value.trim() !== '');
    const dictionaryDisabled = computed(() => {
      return text.value.trim() !== '' || translit.value.trim() !== '';
    });

    const performSearch = async () => {
      const routeName = dictionaryDisabled.value
        ? '/search/texts'
        : '/search/dictionary';

      const { protocol, pathname, host } = window.location;
      const urlParams = new URLSearchParams();

      if (text.value) {
        urlParams.set('title', text.value);
      }

      if (translit.value) {
        urlParams.set('translit', translit.value);
      }

      if (word.value) {
        urlParams.set('dictionary', word.value);
      }

      const newUrl = `${protocol}//${host}${routeName}?${urlParams.toString()}`;
      window.location.href = newUrl;
    };

    const canDictionarySearch = computed(
      () =>
        store.hasPermission('WORDS') ||
        store.hasPermission('NAMES') ||
        store.hasPermission('PLACES')
    );

    const canSearch = computed(
      () => text.value || translit.value || word.value
    );

    const clearSearch = () => {
      text.value = '';
      translit.value = '';
      word.value = '';
    };

    return {
      text,
      translit,
      word,
      performSearch,
      textSearchDisabled,
      dictionaryDisabled,
      clearSearch,
      canSearch,
      canDictionarySearch,
    };
  },
});
</script>

<style scoped>
.sidebar-search-field {
  margin-bottom: 4px;
}

.no-underline {
  text-decoration: none;
}
</style>
